module.exports = __webpack_public_path__ + "img/3@2x.9e16d13a.png";